/* eslint-disable react/prop-types */
import './_Button.scss';
import PropTypes from 'prop-types';

export const Button = ({
  text,
  inverted = false,
  className = 'primary',
  disabled,
  extraStyle,
  type = 'button',
  loading,
  circular,
  ...props
}) => (
  <button
    type={type === 'button' ? 'button' : 'submit'}
    disabled={disabled}
    className={`button--primary button--primary--${className} ${
      inverted ? 'button--primary--inverted' : ''
    }
    ${disabled && 'button--primary--disabled'}
    ${circular && 'button--primary--circular'}
    ${extraStyle}
    `}
    {...props}
  >
    {text}
  </button>
);

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inverted: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  extraStyle: PropTypes.string,
  type: PropTypes.string,
  loading: PropTypes.bool,
  circular: PropTypes.bool,
};
